var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-icon',_vm._b({staticClass:"gl-cursor-help",attrs:{"name":"question-o","size":_vm.sizeInPx,"variant":"info"}},'gl-icon',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }